import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { getDragonBonesImage, isCocosModelAnimationResource as _isCocosModelAnimationResource } from '@/views/creative/utils';
import categoryMixin from '@/views/creative/mixin/category.js';
import AudioContainer from './audio-container.vue';
import FrameSequence from './frame-sequence.vue';
import { v2Host } from '@/config/host';
import { getApiPath } from '@/common/api-proxy';
import { getToken } from '@/utils/auth.js';
import { getFileExtension } from '@com/utils/file';
import { isCocosModelResource } from '@/views/creative/utils';
import { sortFileSrcList } from '@ps/workbench/resource-manager/uploader/xlz';
import { mapState } from 'vuex';
import { addQueryString } from '@com/utils/url';
import imageNotFound from '@com/assets/default_small.png';

export default {
  mixins: [categoryMixin],

  components: {
    AudioContainer: AudioContainer,
    FrameSequence: FrameSequence
  },

  props: {
    category: Object,
    resource: Object,
    preview: {
      type: Boolean,
      default: true
    },
    popoverAttrs: Object,
    audioControls: {
      type: Boolean,
      default: false
    },
    audioOnlyLogo: {
      type: Boolean,
      default: false
    },
    frameSequenceAutoplay: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      visible: false,
      leftTime: '',
      canPlay: false
    };
  },


  computed: _extends({}, mapState({
    previewUrl: function previewUrl(state) {
      return state.creative.template.previewUrl;
    },
    hasMvPlayable: function hasMvPlayable(state) {
      return state.creative.template.hasMvPlayable;
    },
    refreshCover: function refreshCover(state) {
      return state.creative.template.refreshCover;
    },
    replaceMap: function replaceMap(state) {
      return state.creative.modelEditor.replaceMap;
    }
  }), {
    isCocosModel: function isCocosModel() {
      return isCocosModelResource(this.resource);
    },
    isCocosModelAnimationResource: function isCocosModelAnimationResource() {
      return _isCocosModelAnimationResource(this.resource);
    },
    innerClass: function innerClass() {
      return {
        'frame-sequence-resource-container-inner': this.isFrameSequence,
        'image-resource-container-inner': this.isImage,
        'audio-resource-container-inner': this.isAudio,
        'audio-controls-resource-container-inner': this.isAudio && this.audioControls
      };
    },
    innerPopoverAttrs: function innerPopoverAttrs() {
      return _extends({
        trigger: 'hover',
        placement: 'top',
        disabled: this.isAudio || false,
        popperClass: 'resource-previewer-popover',
        openDelay: 500
      }, this.popoverAttrs);
    },
    previewer: function previewer() {
      if (this.isFrameSequence) {
        return {
          url: this.resource.preview_urls,
          type: 'frame-sequence'
        };
      }
      if (this.isDragonBones) {
        return {
          url: this.getDragonBonesImage(this.resource.preview_urls),
          type: 'image'
        };
      }
      if (this.isImage) {
        return {
          url: this.resource.file_url,
          type: 'image'
        };
      }
      return null;
    },
    metaData: function metaData() {
      return this.resource.extra || null;
    },
    previewerStyle: function previewerStyle() {
      if (this.isImage && this.metaData && this.metaData.width && this.metaData.height) {
        return {
          // eslint-disable-next-line no-mixed-operators
          width: this.metaData.width / 2 + 'px',
          // eslint-disable-next-line no-mixed-operators
          height: this.metaData.height / 2 + 'px'
        };
      }
      return null;
    },
    previewUrls: function previewUrls() {
      var urls = _.get(this.resource, 'preview_urls') || [];
      if (this.isFrameSequence) {
        return sortFileSrcList(urls);
      }
      return urls;
    },


    // 视频预览图通过接口动态生成
    videoPreviewUrl: function videoPreviewUrl() {
      var baseUrl = '' + v2Host + getApiPath('/common/video/capture');
      return baseUrl + '?url=' + encodeURIComponent(this.resource.file_url) + '&w=100&_token=' + getToken();
    },
    cocosModelProjectPreviewUrl: function cocosModelProjectPreviewUrl() {
      if (this.metaData && this.metaData.thumb_url) {
        return this.metaData.thumb_url;
      }
      if (!this.previewUrl) return imageNotFound;
      var baseUrl = '' + v2Host + getApiPath('/common/web/capture');
      var modelPreviewUrl = addQueryString(this.previewUrl, {
        model_preview: 1,
        model_path: this.resource.real_file_path,
        disabled_preview_reference: 1,
        disabled_preview_statistic: 1,
        disabled_preview_grid: 1,
        disabled_preview_operation: 1,
        disabled_preview_animation: 1,
        startup_config: 1
      });
      return addQueryString(baseUrl, {
        w: 100,
        url: modelPreviewUrl,
        t: 'model',
        force: this.refreshCover === this.resource.id ? 1 : 0
      });
    },
    cocosModelPreviewUrl: function cocosModelPreviewUrl() {
      var baseUrl = '' + v2Host + getApiPath('/common/web/capture');

      var previewUrl = '/common-viewer/?url=' + this.resource.extra.origin_file_url + '&type=model';
      return baseUrl + '?url=' + encodeURIComponent(previewUrl) + '&w=200';
    },
    modelPreviewUrl: function modelPreviewUrl() {
      var baseUrl = '' + v2Host + getApiPath('/common/web/capture');
      var lmUrl = this.previewUrls.find(function (item) {
        return getFileExtension(item) === 'lm';
      });
      var texUrl = this.previewUrls.find(function (item) {
        return getFileExtension(item) !== 'lm';
      });
      if (!lmUrl) {
        return imageNotFound;
      }
      var previewUrl = location.origin + '/lmpreview/3d.html?lmUrl=' + lmUrl;
      if (texUrl) {
        previewUrl += '&texUrl=' + texUrl;
      }
      return baseUrl + '?url=' + encodeURIComponent(previewUrl) + '&w=200';
    },
    cocosModelAnimationPreviewUrl: function cocosModelAnimationPreviewUrl() {
      if (this.replaceMap && this.replaceMap[this.category.id] && this.replaceMap[this.category.id].thumbUrl) {
        return this.replaceMap[this.category.id].thumbUrl;
      }
      if (this.metaData && this.metaData.thumb_url) {
        return this.metaData.thumb_url;
      }
      return imageNotFound;
    }
  }),

  methods: {
    sortFileSrcList: sortFileSrcList,
    getDragonBonesImage: getDragonBonesImage

    // handleTimeUpdate(audio) {
    //   const leftTime = Number.parseInt(
    //     Math.round(audio.duration) - Math.round(audio.currentTime),
    //     10
    //   )
    //   this.leftTime = leftTime > 0 ? leftTime : 0
    // },

    // handleCanPlay(e) {
    //   this.canPlay = true
    // }
  }
};